<template>
  <v-container fluid tag="section">
    22222
  </v-container>
</template>

<script>

  export default {
    name: 'FinanceCommissionCheckHistory',
    components: {
    },
    data() {
      return {
        tab: 0
      }
    },
    methods: {
    }
  }
</script>
